// extracted by mini-css-extract-plugin
module.exports = {"bottom":"bottom-33tU69VE"};